import { computed, type ComputedRef } from 'vue'

import { useCreditStore } from '../stores/creditStore'

export interface UsePlanSelection {
  requested: ComputedRef<boolean>
  request: () => void
  reset: () => void
}

/**
 * Module 11's public needs-plan seam.
 *
 * Callers publish intent; billing remains the only owner of the state and pricing surface. The
 * boolean signal is deliberately idempotent, so duplicate route invocations cannot stack views.
 */
export function usePlanSelection(): UsePlanSelection {
  const store = useCreditStore()

  return {
    requested: computed(() => store.planSelectionOpen),
    request: store.requestPlanSelection,
    reset: store.resetPlanSelection,
  }
}

/** Framework-light command used by cross-feature flows through `@/features/credits`. */
export function requestPlanSelection(): void {
  useCreditStore().requestPlanSelection()
}

/** Clears a pending takeover after completion, cancellation, logout, or failed navigation. */
export function resetPlanSelection(): void {
  useCreditStore().resetPlanSelection()
}
